import './style.scss';

import React from 'react';
import { connect } from 'react-redux';
import OrderHistoryListItem from './listItem';
import Text from 'components/ui/text';
import View from 'components/ui/view';
import Card from 'components/ui/card';
import LoadingSpinner from 'components/ui/loadingSpinner';
import { loadOrderHistory } from './actions';

let OrderHistory = class OrderHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = { page: 1 };
  }

  componentDidMount() {
    const orders = this.props.orders || [];
    if (!orders.length && !this.props.loading) {
      this.props.loadOrderHistory();
    }
  }

  loadMore() {
    const page = this.state.page + 1;
    this.props.loadOrderHistory({ page }).then(() => {
      this.setState(state => ({ ...state, page: state.page + 1 }));
    });
  }

  render() {
    const orders = this.props.orders || [];
    const canLoadMore = orders.length < this.props.count;

    return (
      <View padding={{ sides: 'md' }} className="order-history banner-padding">
        <Text title tag="h2" weight="med" size="md">
          Your Orders
        </Text>
        <View margin="sm">
          <Card block>
            {this.props.loading &&
              orders.length === 0 && (
                <div
                  style={{
                    minHeight: '300px',
                    position: 'relative',
                    marginTop: '75px'
                  }}
                >
                  <LoadingSpinner black />
                </div>
              )}

            {orders.map(order => (
              <OrderHistoryListItem key={order._id} order={order} />
            ))}
          </Card>
        </View>
        {canLoadMore && (
          <button
            disabled={this.props.loading}
            className="btn--full-width btn--tertiary"
            onClick={() => this.loadMore()}
          >
            Load More Orders
          </button>
        )}
      </View>
    );
  }
};

OrderHistory = connect(
  state => ({
    orders: state.orderHistory.orders,
    loading: state.orderHistory.ordersLoading,
    count: state.orderHistory.count
  }),
  { loadOrderHistory }
)(OrderHistory);

export default OrderHistory;
